export default __webpack_public_path__ + "static/media/osteoplus01.6414befa.jpg";